export default __webpack_public_domain__ + __webpack_public_url__ + __webpack_public_path__ + "static/media/eteams_wechat.jpg?v=eb68bb40";